(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatDetailController', ChatDetailController);

    ChatDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Chat', 'ChatMessage', 'Customer'];

    function ChatDetailController($scope, $rootScope, $stateParams, previousState, entity, Chat, ChatMessage, Customer) {
        var vm = this;

        vm.chat = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:chatUpdate', function(event, result) {
            vm.chat = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
